import { render, staticRenderFns } from "./types-list.vue?vue&type=template&id=3b98315d"
import script from "./types-list.vue?vue&type=script&lang=js"
export * from "./types-list.vue?vue&type=script&lang=js"
import style0 from "./types-list.vue?vue&type=style&index=0&id=3b98315d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports